/* @flow */
const contractRoutes = {
  assignedUsersToContract: '/assets/account/:accountId/user/:userId/contract/:contractId',
  activity: 'contracts/:contractId/activity',
};

export default contractRoutes;
